import { useEffect, useRef } from 'react';
import { DEFAULT_INACTIVITY_TIMEOUT } from '../@constants/timer';

type UseInactivityLogoutProps = {
  callBack: () => void;
  timeout?: number; // optionnel, pour personnaliser la durée
};

export function useInactivity({
  callBack,
  timeout = DEFAULT_INACTIVITY_TIMEOUT,
}: UseInactivityLogoutProps) {
  const timerRef = useRef<number | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => {
      callBack();
    }, timeout);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    events.forEach(event => window.addEventListener(event, resetTimer));

    // Lancer le premier timer
    resetTimer();

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [timeout, callBack]);
}
